import Careers from "../components/site/Careers";

export default function CareersPage() {
  return (
    <div className="pt-24">
      <Careers />
    </div>
  );
}
